<template>
    <div class="auction-halls-program">
        <div class="image-card" :style="'background-image:url(' + program?.thumb?.url + ');'">
            <div class="image-card__inner">
                <div class="image-card__con">
                    <h3 class="image-card__tit">{{ program?.subject }}</h3>
                    <div class="image-card__info">
                        <ul>
                            <li v-if="at">
                                <strong>일시</strong><span>{{ at }}</span>
                            </li>
                            <li v-if="duration">
                                <strong>기간</strong><span>{{ duration }}</span>
                            </li>
                            <li v-if="program?.location">
                                <strong>장소</strong><span>{{ program?.location }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api";

const days_ko = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        value: { type: Object, default: null },
        _program: { type: String, default: null },
    },
    data: () => ({
        program: null,
    }),
    computed: {
        at() {
            let { at } = this.program || {};
            if (at) {
                at = dayjs(at);
                const date = at.format("YYYY년 M월 D일");
                const day = days_ko[at.day()];
                const ampm = at.hour() >= 12 ? "PM" : "AM";
                const time = at.format("hh:mm");

                return `${date} (${day}) ${ampm} ${time} KST`;
            }

            return null;
        },
        duration() {
            let { duration: { startsAt, endsAt } = {} } = this.program || {};
            if (startsAt && endsAt) {
                startsAt = dayjs(startsAt);
                endsAt = dayjs(endsAt);
                const day_startsAt = days_ko[startsAt.day()];
                const day_endsAt = days_ko[endsAt.day()];

                const isSameYear = startsAt.year() == endsAt.year();
                if (isSameYear) endsAt = endsAt.format("M월 D일");
                else endsAt = endsAt.format("YYYY년 M월 D일");
                startsAt = startsAt.format("YYYY년 M월 D일");

                return `${startsAt} (${day_startsAt}) ~ ${endsAt} (${day_endsAt})`;
            }

            return null;
        },
    },
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        _string() {
            this.init();
        },
    },
    methods: {
        sync() {
            this.program = this.value;
        },
        emit() {
            this.$emit("input", this.program);
        },
        async init() {
            const { program } = await api.v1.auction.programs.get({ _id: this._program });
            this.program = program;
            this.emit();
        },
    },
};
</script>

<style>
</style>